var map = {
	"./argentina.json": 4611,
	"./australia.json": 7993,
	"./brazil.json": 6345,
	"./france.json": 3955,
	"./germany.json": 7244,
	"./italy.json": 7525,
	"./master.json": 7382,
	"./mexico.json": 4015,
	"./portugal.json": 8346,
	"./spain.json": 4965,
	"./testing.json": 3886,
	"./uk.json": 2282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6118;